import dynamic from "next/dynamic"
import { useMemo } from "react"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import { FindButtonProps } from "../FindDesignTypes"
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import useTheme from "@mui/material/styles/useTheme";
import Link from "next/link"
import { filterUrl } from "../Find"
import { PageType } from "../../../../pages/_app"
import { FilterBaseProps } from "../Find.types"

const FilterCondition = ({
  filters,
  colors,
  pageUrl,
  mmbr,
  isMobile
}: FilterBaseProps) => {
  const { partnerSiteFull, templatePath } = useLayoutData()
  const theme = useTheme()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindButton = useMemo(() => dynamic<FindButtonProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindButton)), [path])
  const isFull = useMediaQuery(theme.breakpoints.down('xl'))

  return (
    <>
      <Grid 
        container
        display={"flex"}
        alignItems={"center"}
        justifyContent={isMobile ? "center" : "space-between"}
        gap={1}
        flexWrap={"nowrap"}
        flexDirection={"row"}
        margin={"auto"}
      >
        {filters?.items?.map((item, i) => (
          <Grid key={i} item width={isMobile ? 100 : "100%"}>
            {item.disabled ? (
              <FindButton
                variant="outlined"
                bgcolor={colors.mainColor}
                bghovercolor={colors.secondaryColor}
                conditionbutton={1}
                selected={Number(item.selected ?? 0)}
                fullWidth={isFull}
                sx={{ width: "100%" }}
                disabled={item.disabled}
                aria-label={item.title}
              >
                <Grid container flexWrap={"wrap"}>
                  <Grid item xs={12} flexWrap={"nowrap"} fontSize={{ xs: 12, md: 10, lg: 12 }}>{item.title}</Grid>
                  <Grid item xs={12} flexWrap={"nowrap"} fontSize={{ xs: 11, md: 8, lg: 11 }}><span>({item.count})</span></Grid>
                </Grid>
              </FindButton>
            ) : (
              <Link href={filterUrl(filters, item, undefined, pageUrl, mmbr)} scroll={false} passHref>
                <a>
                  <FindButton
                    variant="outlined"
                    bgcolor={colors.mainColor}
                    bghovercolor={colors.secondaryColor}
                    conditionbutton={1}
                    selected={Number(item.selected ?? 0)}
                    fullWidth={isFull}
                    sx={{ width: "100%" }}
                    disabled={item.disabled}
                  >
                    <Grid container flexWrap={"wrap"}>
                      <Grid item xs={12} flexWrap={"nowrap"} fontSize={{ xs: 12, md: 10, lg: 12 }}>{item.title}</Grid>
                      <Grid item xs={12} flexWrap={"nowrap"} fontSize={{ xs: 11, md: 8, lg: 11 }}><span>({item.count})</span></Grid>
                    </Grid>
                  </FindButton>
                </a>
              </Link>
            )}
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default FilterCondition